import { all, fork } from "redux-saga/effects";

type Saga = any;
export const combineSagas = (sagas: Array<Saga>) =>
  function* rootSaga() {
    yield all(sagas.map((saga) => fork(saga)));
  };
